import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zidian-h",
  "use": "icon-zidian-h-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-zidian-h\">\n  <path d=\"M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z\" />\n  <polyline points=\"14 2 14 8 20 8\" />\n  <line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" />\n  <line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" />\n  <line x1=\"10\" y1=\"9\" x2=\"8\" y2=\"9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zidian-h.svg
// module id = t2yQ
// module chunks = 96